import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
//import SibebarSeleccionContratacion from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import { Link } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarModuloNotificaciones from "../../../components/Modulo_Notificaciones/SidebarModuloNotificaciones";

const Admin = () => {
  const [show, setShow] = useState(true);
  //* Method
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarModuloNotificaciones show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="jumbotron ft-banner">
            <main>
              <h1>Notificaciones</h1>
              <p className="mb-4 text-muted">
                El módulo de notificaciones permite a los usuarios gestionar el envío de alertas y mensajes de manera eficiente. Los usuarios pueden personalizar el contenido y el formato de las notificaciones según sus necesidades específicas
              </p>
              <Row>
                <Col>
                  <h4>Mantenimientos Notificaciones</h4>
                  <ul className="ml-3 p-0">
                    
                    {/* <li>
                      <Link to="/sucesion/criticidad">
                        Mantenimiento de criticidad
                      </Link>
                    </li> */}
                    {/* <li>
                      <Link to="/conf-notificaciones/admin/tipo-notificacion">
                        Mantenimiento de tipo de notificación
                      </Link>
                    </li>
                    
                    <li>
                      <Link to="/conf-notificaciones/admin/tipo-colaborador">
                      Mantenimiento de tipo de colaborador
                      </Link>
                    </li>   */}
                    <li>
                      <Link to="/conf-notificaciones/admin/segmento">
                        Mantenimiento de segmento
                      </Link> 
                    </li>                  
                  </ul>
                </Col>
              </Row>
            </main>
           
          </div>
        </Container>
      </div>
    </>
  );
};

export default Admin;
